import apiClient from './apiClient';
import { GET_TRANSACTION_BY_ID_URL } from './apiUrl';

const getTransactionByIdApi = code => {
  return apiClient.get(GET_TRANSACTION_BY_ID_URL(code));
};

export default getTransactionByIdApi;
